var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottombox"},[_c('p',{staticClass:"pone"},[_vm._v("我的工具")]),_c('div',{staticClass:"boxinfo"},_vm._l((_vm.funbox),function(item,index){return _c('funboxitem',{key:index,attrs:{"hownum":_vm.funbox.length,"item":item,"bottomtext":'#666666',"imgInfo":item.imgInfo},on:{"nopath":_vm.nopath}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }